import { L, } from '../leaflet/leaflet';
import { L_latLng, } from '../leaflet/leaflet-util';
import { _$id, _addEventListener, } from '../util/dom';
import { _addStoreHandlers, } from '../service/store';
import { _s2coord, _coord2s, } from '../service/coord-encoding';
const L_tileLayer = L.tileLayer, L_control = L.control, _$osmOpacitySlider = _$id('osm-opacity'), _$otmOpacitySlider = _$id('otm-opacity'), _setOpacity = ($layer) => (event) => {
    const $rangeInput = event.target, opacityStr = $rangeInput.value, opacity = Number(opacityStr);
    $layer.setOpacity(opacity);
}, _$aerialTileLayer = L_tileLayer('https://{s}.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
    subdomains: ['server', 'services'],
    maxNativeZoom: 19,
    maxZoom: 23,
    noWrap: false,
    attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
}), _$osmTileLayer = L_tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxNativeZoom: 19,
    maxZoom: 23,
    noWrap: false,
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
}), _$otmTileLayer = L_tileLayer('https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png', {
    maxNativeZoom: 17,
    maxZoom: 23,
    noWrap: false,
    attribution: 'Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
}), _$map = L.map('map', {
    doubleClickZoom: false,
    zoomControl: false,
}), _$layerControl = L_control.layers(null, {
    'ESRI World Imagery': _$aerialTileLayer,
    'OpenStreetMap': _$osmTileLayer,
    'OpenTopoMap': _$otmTileLayer,
}), _$zoomControl = L_control.zoom({
    position: 'topright',
}), _$scale = L_control.scale({
    maxWidth: 240,
    metric: true,
    imperial: true,
    position: 'topright',
}), _loadMapPosition = (dataStr) => {
    if (dataStr) {
        const [xStr, yStr, zStr] = dataStr.split(_dataSep), lat = _s2coord(xStr), lng = _s2coord(yStr), latLng = L_latLng(lat, lng), zoom = parseInt(zStr);
        _$map.setView(latLng, zoom);
    }
    else {
        _$map.setView(_stdLatLng, _stdZoom);
    }
}, _stdLatLng = L_latLng(0, 0), _stdZoom = 2, _storeMapPosition = () => {
    const latLng = _$map.getCenter(), xStr = _coord2s(latLng.lat), yStr = _coord2s(latLng.lng), zoom = _$map.getZoom(), zStr = zoom.toString();
    return xStr + _dataSep + yStr + _dataSep + zStr;
}, _loadPlainLayerSettings = ($layer) => (isOnStr) => {
    _maybeAddLayer($layer, isOnStr);
}, _maybeAddLayer = ($layer, isOnStr) => {
    if (isOnStr === undefined && $layer === _$aerialTileLayer) {
        _$map.addLayer($layer);
        return;
    }
    const isOn = !!parseInt(isOnStr, 2);
    if (isOn) {
        _$map.addLayer($layer);
    }
    else {
        _$map.removeLayer($layer);
    }
}, _storePlainLayerSettings = ($layer) => () => _layerToggleStr($layer), _layerToggleStr = ($layer) => _$map.hasLayer($layer) ? '1' : '0', _loadOpacityLayerSettings = ($layer, $opacitySlider) => (dataStr) => {
    if (!dataStr) {
        return;
    }
    const [isOnStr, opacityStr] = dataStr.split(_dataSep), scaledOpacity = parseInt(opacityStr, _opacityRadix), opacity = scaledOpacity / _opacityMultiplier;
    $layer.setOpacity(opacity);
    $opacitySlider.value = opacity.toString();
    _maybeAddLayer($layer, isOnStr);
}, _storeOpacityLayerSettings = ($layer, $opacitySlider) => () => {
    const isOnStr = _layerToggleStr($layer), opacity = Number($opacitySlider.value), scaledOpacity = Math.round(opacity * _opacityMultiplier), opacityStr = scaledOpacity.toString(_opacityRadix);
    return isOnStr + _dataSep + opacityStr;
}, _opacityRadix = 16, _opacityMultiplier = 0xff, _dataSep = ',', _loadAerialSettings = _loadPlainLayerSettings(_$aerialTileLayer), _storeAerialSettings = _storePlainLayerSettings(_$aerialTileLayer), _loadOsmSettings = _loadOpacityLayerSettings(_$osmTileLayer, _$osmOpacitySlider), _storeOsmSettings = _storeOpacityLayerSettings(_$osmTileLayer, _$osmOpacitySlider), _loadOtmSettings = _loadOpacityLayerSettings(_$otmTileLayer, _$otmOpacitySlider), _storeOtmSettings = _storeOpacityLayerSettings(_$otmTileLayer, _$otmOpacitySlider);
_$scale.addTo(_$map);
_$layerControl.addTo(_$map);
_$zoomControl.addTo(_$map);
_addEventListener(_$osmOpacitySlider, 'change', _setOpacity(_$osmTileLayer));
_addEventListener(_$otmOpacitySlider, 'change', _setOpacity(_$otmTileLayer));
_addStoreHandlers('m', _loadMapPosition, _storeMapPosition);
_addStoreHandlers('i', _loadAerialSettings, _storeAerialSettings);
_addStoreHandlers('s', _loadOsmSettings, _storeOsmSettings);
_addStoreHandlers('t', _loadOtmSettings, _storeOtmSettings);
export { _$map, };
